import TitleContainer from "../Layout/TitleContainer";
import AboutHeuguchon from "./AboutHeuguchon";
import AboutRoadmap from "./AboutRoadmap";

const About = () => (
    <>
        <TitleContainer title="소개" description="흑우촌 메타버스를 소개합니다" style={{'bkg-green': true, 'color-white': true}} />
        <AboutHeuguchon />
        <AboutRoadmap />
    </>
);

export default About;